"use strict";
window.theme = window.theme || {}
theme.ComponentsSigninBeforeCheckout = function() {
    function ComponentsSigninBeforeCheckout() {
        this.container = {
            registerform: document.querySelector('.Container > .three-columns-container > .sign-up > .register-form'),
            signin: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.signin-form-before-checkout'),
            forgotpassword: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout'),
            siginerror: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container>.sign-in > form.signin-form-before-checkout > .content > .error-container > p.error'),
            resetpassworderrorincorrect: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout > .content > .error-container > p.error-incorrect'),
            resetpassworderrortooattempts: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout > .content > .error-container > p.error-attempts'),
            resetpassworderrorsuccess: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout > .content > .error-container > p.error-success'),
            main: document.querySelector('.sign-in-before-checkout'),
            mobilesignin: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in'),
            mobilesignup: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-up'),
            mobileguest: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .guest'),
            maincart: document.querySelector('#main-cart.Container')
        };
        this.login = {
            email: document.querySelector('form.signin-form-before-checkout > .content > input[type="email"]'),
            password: document.querySelector('form.signin-form-before-checkout > .content > input[type="password"]'),
            btn: document.querySelector('form.signin-form-before-checkout > button[type="submit"]')
        }
        this.button = {
            signup: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-up > button'),
            forgotpassword: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form > .content > p.forgot-password'),
            forgotpasswordcancel: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form > button[type="button"]'),
            guest: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .guest > button'),
            crosseye: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > .signin-form-before-checkout > .content > i.cross-eye'),
            openeye: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > .signin-form-before-checkout > .content > i.open-eye'),
            checkout: document.querySelector('.Cart__Checkout.Button'),
            close: document.querySelector('.sign-in-before-checkout-close'),
            resetsubmit: document.querySelector('.sign-in-before-checkout>.Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout > .content > button[type=submit]'),
            menu: document.querySelectorAll('.sign-in-before-checkout > .Container > .header-sigin > ul.mobile-tab-menu > li'),
            signinspin: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.signin-form-before-checkout > button > .spinner'),
            resetpasswordspin: document.querySelector('.sign-in-before-checkout>.Container>.three-columns-container>.sign-in>form.forgot-password-form-before-checkout>.content>button[type=submit] > .spinner')
        }
        this.input = {
            resetpasswordemail: document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-in > form.forgot-password-form-before-checkout > .content > input'),
            termsofsalesMain: document.querySelector('.terms-of-sale-checkbox'),
            termsofsales: document.querySelector('.terms-of-sale-checkbox > .terms-of-sale-checkbox-label > input[name="terms-of-sale"]')
        }
        this.formSerialize = {
            datalogin: new FormData(),
            datareset: new FormData()
        }
        this.form_input = {
            createbutton: null
        }
        this.load();               

    }
    ComponentsSigninBeforeCheckout.prototype.load = function() {
        var _ = this;
        if(_.login.btn) {
            _.login.btn.addEventListener('click', event => {
                if(_.login.email.value !== '' && _.login.password.value !== '') {
                    event.preventDefault();
                    _.signin();
                }
            })
        }       
        if(_.button.signup) {
            _.button.signup.addEventListener('click', event => {
               _.container.registerform.classList.toggle('active');  
                    _.sleep(100).then(() => {
                        _.container.main.scrollTo({
                            top: 410,
                            left: 0,
                            behavior: 'smooth'
                        });  
                    });                                            
            })
        }     
        if(_.button.forgotpassword) {
            _.button.forgotpassword.addEventListener('click', event => {
               _.container.forgotpassword.classList.toggle('active');
               _.container.signin.classList.toggle('active');
            })
        }       
        if(_.button.forgotpasswordcancel) {
            _.button.forgotpasswordcancel.addEventListener('click', event => {
               _.container.forgotpassword.classList.toggle('active');
               _.container.signin.classList.toggle('active');
               _.container.resetpassworderrortooattempts.classList.remove('active');
               _.container.resetpassworderrorincorrect.classList.remove('active');
               _.container.resetpassworderrorsuccess.classList.remove('active');
               _.input.resetpasswordemail.value = '';
            })
        }   
        if(_.button.guest) {
            _.button.guest.addEventListener('click', event => {
              location.replace('/checkout');
            })
        }  
        if(_.button.crosseye) {
            _.button.crosseye.addEventListener('click', event => {
                event.target.closest('i').classList.toggle('active');
                _.button.openeye.classList.toggle('active');
                _.login.password.setAttribute('type','text');
            })
        }       
        if(_.button.openeye) {
            _.button.openeye.addEventListener('click', event => {
                event.target.closest('i').classList.toggle('active');
                _.button.crosseye.classList.toggle('active');
                _.login.password.setAttribute('type','password');
            })
        }   
        if(_.button.checkout) {
            _.button.checkout.addEventListener('click', event => {
                const isTermsChecked = _.input.termsofsales.checked;
    
                if (!isTermsChecked) {
                    _.button.checkout.setAttribute('disabled','');
                    _.input.termsofsalesMain.insertAdjacentHTML('beforeend', '<p class="Form__Alert Alert Alert--error Alert--error-terms">Please agree to the Terms of Sale</p>')
                } else {
                    location.replace('/checkout');
                }
            })
        } 
        if(_.button.close) {
            _.button.close.addEventListener('click', event => {
                _.container.main.classList.remove('active');
                _.container.maincart.style.removeProperty('height');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('touch-action');
                document.body.style.removeProperty('-ms-touch-action');
                _.container.registerform.classList.remove('active');
            })
        }      
        if(_.button.resetsubmit) {
            _.button.resetsubmit.addEventListener('click', event => {
                if(_.input.resetpasswordemail.value !== '') {
                    event.preventDefault();
                    _.recovery();
                }
            })
        }     
        document.addEventListener('cf:ready', function() {
            _.form_input.createbutton = document.querySelector('.cf-form-actions > button.cf-button');
            let recaptchabadge = document.createElement('div');
            let privacypolicy = document.createElement('a');
            let privacypolicyafter = document.createElement('span');
            /*privacypolicy.href = '/pages/privacy-policy';
            privacypolicy.textContent = 'I agree to receive information by email about offers, services, products and events from The Botanist.';
            privacypolicy.setAttribute('target', '_blank');
            privacypolicy.setAttribute('rel', 'noopener');
            privacypolicy.classList.add('signin-checkout-privacy-policy');
            */
            recaptchabadge.classList.add('g-recaptcha');
            recaptchabadge.setAttribute('data-sitekey', '6LeE5IwhAAAAABFHzSnOU9gee2miMCQk-sTgWa96');
            recaptchabadge.setAttribute('data-callback','checkoutcallback');      
            privacypolicyafter.textContent = 'I agree to receive information by email about offers, services, products and events from The Botanist. You can unsubscribe from email marketing communications via the "Unsubscribe" link at the bottom of each of our email communications.'
                let recaptchafound = document.querySelector('.cf-field.privacy-cookie-policy');

                const getPrivacyDiv = document.querySelector('.cf-field-container.privacy-cookie-policy p');
            const getSubmitDiv = document.querySelector('div.cf-form-actions'); 

            getSubmitDiv.appendChild(getPrivacyDiv);

                if(recaptchafound) {                           
                    recaptchafound.insertBefore(recaptchabadge,recaptchafound.children[0]);
                    let registerbutton = document.querySelector('.sign-in-before-checkout .cf-form-actions button');
                    document.querySelector('.cf-submit-form.cf-button').setAttribute('disabled','');
                    _.sleep(100).then(() => {
                        let privacypolicylink = document.querySelector('.cf-field.privacy-policy-checkbox > label.cf-enum-field__choice > span');
                        let checkboxbg = document.querySelector('.sign-in-before-checkout > .Container > .three-columns-container > .sign-up > .register-form > form > .cf-react-target > .cf-form-inner .cf-field.privacy-policy-checkbox > label > input[type="checkbox"]');
                        privacypolicylink.textContent = privacypolicylink.textContent + ' ';
                        privacypolicylink.append(privacypolicy);
                        privacypolicylink.append(privacypolicyafter);
                        registerbutton.addEventListener('click', event => {
                            _.setcookie();
                        })
                        let checkboxlabel = document.createElement('p');
                        checkboxlabel.classList.add('checkbox-label');
                        checkboxbg.parentElement.insertBefore(checkboxlabel,checkboxbg.parentElement.children[1]);
                    });
    
                };
            })
        if(_.button.menu.length > 0) {
            _.button.menu.forEach(btn => {
                btn.addEventListener('click', event => {
                    _.button.menu.forEach(li => {
                        li.classList.remove('active');
                    });
                    event.target.closest('li').classList.add('active');
                    if(event.target.closest('li').getAttribute('data-menu') === 'signin') {
                        _.container.mobilesignin.classList.add('active');
                        _.container.mobilesignup.classList.remove('active');
                        _.container.mobileguest.classList.remove('active');
                    }
                    if(event.target.closest('li').getAttribute('data-menu') === 'signup') {
                        _.container.mobilesignin.classList.remove('active');
                        _.container.mobilesignup.classList.add('active');
                        _.container.mobileguest.classList.remove('active');
                    }
                    if(event.target.closest('li').getAttribute('data-menu') === 'guest') {
                        _.container.mobilesignin.classList.remove('active');
                        _.container.mobilesignup.classList.remove('active');
                        _.container.mobileguest.classList.add('active');
                    }
                })
            })

            
        }
    }
    ComponentsSigninBeforeCheckout.prototype.signin = function() {
        var _ = this;
        _.formSerialize.datalogin.append('form_type', 'customer_login');
        _.formSerialize.datalogin.append('utf8', '✓');
        _.formSerialize.datalogin.append('customer[email]', _.login.email.value);
        _.formSerialize.datalogin.append('customer[password]', _.login.password.value);
        _.button.signinspin.classList.add('active');
        fetch('/account/login', {
            method: 'POST',
            body: _.formSerialize.datalogin
        })
        .then(response => response.text())
        .then(data => {
            if(data.indexOf('Incorrect email or password.') !== -1) {
                _.container.siginerror.classList.add('active');
            } else {
                _.container.siginerror.classList.remove('active');
                location.replace('/checkout');
            }
            _.button.signinspin.classList.remove('active');
        })
        .catch(error => console.log(error));       
    }
    ComponentsSigninBeforeCheckout.prototype.recovery = function() {
        var _ = this;
        _.formSerialize.datareset.append('form_type', 'recover_customer_password');
        _.formSerialize.datareset.append('utf8', '✓');
        _.formSerialize.datareset.append('email', _.input.resetpasswordemail.value);
        _.button.resetpasswordspin.classList.add('active');
        fetch('/account/recover', {
            method: 'POST',
            body: _.formSerialize.datareset,
            redirect: 'follow'
        })
        .then(response => response.text())
        .then(data => {
            if(data.indexOf('Too many attempts: Please try again later.') !== -1) {
               _.container.resetpassworderrortooattempts.classList.add('active');
               _.container.resetpassworderrorincorrect.classList.remove('active');
               _.container.resetpassworderrorsuccess.classList.remove('active');
            } else if (data.indexOf('No account found with that email.') !== -1) {
                _.container.resetpassworderrortooattempts.classList.remove('active');
                _.container.resetpassworderrorincorrect.classList.add('active');
                _.container.resetpassworderrorsuccess.classList.remove('active');
            } else {
                _.container.resetpassworderrortooattempts.classList.remove('active');
                _.container.resetpassworderrorincorrect.classList.remove('active');
                _.container.resetpassworderrorsuccess.classList.add('active');
            }
            _.button.resetpasswordspin.classList.remove('active');
        })
        .catch(error => console.log(error));       
    }
    ComponentsSigninBeforeCheckout.prototype.setcookie = function() {
        var _ = this;
        let noday = 30;
        const d = new Date();
        d.setTime(d.getTime() + (noday*24*60*60*1000));
        let expires = 'expires='+ d.toUTCString();
        document.cookie = 'register_before_checkout=true;' + expires + ';path=/';
    }
    ComponentsSigninBeforeCheckout.prototype.getcookie = function() {
        let name = 'register_before_checkout=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return 'false';
    }
    ComponentsSigninBeforeCheckout.prototype.sleep = function(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    ComponentsSigninBeforeCheckout.prototype.recaptchacallback = function() {
        var _ = this;
        var response = grecaptcha.getResponse();
        if(response.length > 0) {
            _.form_input.createbutton.removeAttribute('disabled');
        } else {
            _.form_input.createbutton.setAttribute('disabled','');
        }
    }

    theme.ComponentsSigninBeforeCheckout = new ComponentsSigninBeforeCheckout;
}

theme.ComponentsSigninBeforeCheckout();
